import state from './moduleCrewAssignmentManagementState'
import mutations from './moduleCrewAssignmentManagementMutations'
import actions from './moduleCrewAssignmentManagementActions'
import getters from './moduleCrewAssignmentManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}